import { Attributes, Misc, ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class TaxSummaryLookup extends ModelBase {  
  @Attributes.Date(Misc.TimeZoneFormat.None)
  public batchDate: Date = new Date();

  @Attributes.Date(Misc.TimeZoneFormat.None)
  public holdingReportingDate: Date = new Date();

  public clientNumber: string = "";

  public clientName: string = "";
  
  public brokerAccountNumber: string = "";

  public brokerAccountCurrency: string = "";

  public realisedGainOrLoss: number | null = null;

  public realisedGainOrLossNC: number | null = null;

  public incomeDeclared: number | null = null;

  public incomeDeclaredNC: number | null = null;

  public dividendsDeclared: number | null = null;

  public dividendsWithholdingTax: number | null = null;

  public interestWithholdingTax: number | null = null;

  public unrealisedGainOrLossNC: number | null = null;

  public dividendsDeclaredNC: number | null = null;

  public dividendsWithholdingTaxReportedNC: number | null = null;

  public interestWithholdingTaxReportedNC: number | null =  null;

  public provisionalCGTValueNC: number | null = null;

  public provisionalIWTValueNC: number | null = null;

  public provisionalDWTValueNC: number | null = null;
}